<script setup>
import { getChartTracks } from '../../../utils/getChartTracks.js'

const { item } = defineProps({ item: Object })

const tracks = computed(() => getChartTracks(item.enrichment.chart, 3))
const currentPosition = computed(() => item.enrichment.chart.currentPosition)
</script>

<template>
  <div class="space-y-24 ml-[569px] -mt-[198px]">
    <div class="bg-joe-cr-blue-darker w-[2264px] h-[396px] rounded-full" />
    <div
      v-for="(track, position) in tracks"
      :key="track?.id"
      class="w-[2264px] h-[396px] rounded-full flex items-center text-white px-[168px] font-geomanist gap-20"
      :class="position == currentPosition ? 'bg-joe-cr-rose-primary' : 'bg-joe-cr-blue-darker'"
    >
      <div class="text-[16rem] font-bold w-[450px] text-center">{{ position }}</div>
      <div v-if="track" class="leading-none space-y-2">
        <div class="text-[9rem] font-bold line-clamp-1">{{ track.title }}</div>
        <div class="text-[6rem] line-clamp-1">{{ track.artist.name }}</div>
      </div>
      <div v-else class="leading-none space-y-2 flex flex-col items-start">
        <div class="h-[9rem] w-[1050px] font-bold line-clamp-1 blur-2xl bg-white/50" />
        <div class="h-[6rem] w-[500px] line-clamp-1 blur-2xl bg-white/30" />
      </div>
    </div>
    <div class="bg-joe-cr-blue-darker w-[2264px] h-[396px] rounded-full" />
    <div class="bg-joe-cr-blue-darker w-[2264px] h-[396px] rounded-full" />
    <div class="bg-joe-cr-blue-darker w-[2264px] h-[396px] rounded-full" />
  </div>
</template>
